<div class="flex flex-col items-center justify-between gap-2">
    <div class="h-5 w-full flex items-center animate-pulse">
        <div class="h-2 {{bgClass}} animate-pulse rounded float-left w-3/4"></div>
    </div>
    <div class="w-full rounded border-2 {{bgClass}} {{borderClass}} {{customHeightClass}} animate-pulse"></div>
</div>